function DesktopSkeleton() {
  return <div style={{ width: '100vw', height: '100vh', maxWidth: '100%' }} />;
}

export default DesktopSkeleton;
